"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = bound;
/**
 *
 */
var atLeast = exports.atLeast = function atLeast(value, min) {
	return value < min ? min : value;
};

/**
 *
 */
var atMost = exports.atMost = function atMost(value, max) {
	return value > max ? max : value;
};

/**
 *
 */
function bound(value, min, max) {
	var endless = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

	if (value < min) {
		return endless ? max : min;
	}

	if (value > max) {
		return endless ? min : max;
	}

	return value;
}